import { useEffect, useState } from "react";
import {
  ForetakMedLenker,
  PersonMedFullmakter,
} from "../infrastructure/api/api";
import { findURIAndReplaceOrigin } from "../infrastructure/entrypoint/link";
import { getPossibleUndefinedJSON } from "../infrastructure/api/digipost-fetch";
import { useEntrypointContext } from "../infrastructure/entrypoint/EntrypointContext";

export function useProkuraVirksomheter() {
  const [prokuraForetak, setProkuraForetak] = useState<ForetakMedLenker[]>([]);
  const [harHentetProkuraForetak, setHarHentetProkuraForetak] =
    useState<boolean>(false);

  const entrypoint = useEntrypointContext();

  useEffect(() => {
    let active = true;

    void load();
    return () => {
      active = false;
    };

    async function load() {
      const url = findURIAndReplaceOrigin(
        "registrerbare-selskaper",
        entrypoint._links,
      );
      const res = await getPossibleUndefinedJSON<PersonMedFullmakter>(url);

      if (!active) return;
      setProkuraForetak(res?.foretak ?? []);
      setHarHentetProkuraForetak(true);
    }
  }, [entrypoint._links]);

  return { prokuraForetak, harHentetProkuraForetak };
}
